// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__hUGS-","selects":"Documents_selects__1-wp_"};